module.exports = __webpack_public_path__ + "fd3f0130fd07ce8f26fb1ee36836f933.svg";